import { Dictionary } from "lodash";
import { createEntityStore } from "./entityStore";

export type LandCode = "CZ" | "SK" | "HU" | "EE" | "LV" | "HR" | "SI" | "PL";

export interface DefaultValuesDto {
    landCode: LandCode;
    language: string;
    showEurAr: boolean;
    euroRate: number;
    mailId: number;
    currency: string;
    fstPstAmt?: number;
    maxDunLvl?: number;
    isTmOrderConfirmationRequired: boolean;
    customerReturnTransactionCodeId: number | null;
    customerReturnWarehouseId: number | null;
    postalReturnTransactionCodeId: number | null;
    postalReturnWarehouseId: number | null;
    allowComgatePaymentLinks: boolean;
    allowedCharacters: string;
    allowedCharactersDict: Dictionary<boolean>;
    overrideCharacters: string;
    overrideCharactersDict: Dictionary<string>;
}

export const DefaultDunningLevelLevel = -1;
export const DefaultCycleId = -1;

export const useDefaultValues = createEntityStore<DefaultValuesDto>({
    path: "enums/defaultValues", data: {
        landCode: "CZ",
        language: "CZ",
        showEurAr: false,
        euroRate: 1,
        mailId: 0,
        currency: "",
        isTmOrderConfirmationRequired: false,
        customerReturnTransactionCodeId: null,
        customerReturnWarehouseId: null,
        postalReturnTransactionCodeId: null,
        postalReturnWarehouseId: null,
        allowComgatePaymentLinks: false,
        allowedCharacters: "",
        allowedCharactersDict: {},
        overrideCharacters: "",
        overrideCharactersDict: {},
    },
    transformFetchedData(data) {
        data.allowedCharactersDict = {};
        for (const char of data.allowedCharacters) {
            data.allowedCharactersDict[char] = true;
        }
        data.overrideCharactersDict = {};
        const chunks = chunkString(data.overrideCharacters, 2);
        for (const chunk of chunks) {
            data.overrideCharactersDict[chunk.charAt(0)] = chunk.charAt(1);
        }
        return data;
    }
});

export function chunkString(str: string, size: number) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array<string>(numChunks);

    for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
        chunks[i] = str.substring(o, o + size);
    }

    return chunks;
}
